import { useState } from "react";
import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

export default function Accordion({
  title,
  subtitle,
  defaultOpen = true,
  forceOpen = false,
  children,
}: {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  forceOpen?: boolean;
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const isExpanded = forceOpen ? true : isOpen;

  return (
    <div className="accordion">
      <button
        className="accordion-header"
        onClick={() => {
          if (forceOpen) return;
          setIsOpen(!isOpen);
        }}
      >
        <div className="accordion-title-block">
          <div className="accordion-title">{title}</div>
          {subtitle && <div className="accordion-subtitle">{subtitle}</div>}
        </div>
        <ChevronDown
          size={20}
          className="accordion-chevron"
          style={{
            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </button>
      {isExpanded && <div className="accordion-content">{children}</div>}
    </div>
  );
}
